import { Update } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { getRelativeTime } from '../../../../../util/date';

interface DateInfoProps {
    createdAt: Dayjs;
    updatedAt: Dayjs;
}

export const DateInfo = ({ createdAt, updatedAt }: DateInfoProps) => (
    <Stack alignItems='flex-end'>
        <Stack direction="column" gap={.7} justifyContent='flex-end'>
            <DateText text="Created" date={createdAt} />
            <DateText text="Last Updated" date={updatedAt} />
        </Stack>
    </Stack>
);

const DateText = ({ text, date }: { text: string, date: Dayjs }) => (
    <Stack direction="row" alignItems='center' gap={2} flexWrap='wrap' justifyContent='space-between'>
        <Stack direction="row" alignItems='center' gap={1}>
            <Update color="action" fontSize="small" sx={{ opacity: 0.6 }} />
            <Typography color="text.secondary" variant="caption" fontWeight='bold'>{text}</Typography>
        </Stack>
        <Typography variant="caption" color='text.secondary' sx={{ opacity: 0.8 }}>
            {getRelativeTime(date.toString())}
        </Typography>
    </Stack>
); 